import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.list');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { IProject } from '../@types';

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-project-list',
template: templateSource || '',
    styles: [``],
})
export class PageProjectListComponent implements OnInit {
    /** 신규 프로젝트 추가 모달 표시 여부 */
    public is_add_project: boolean = false;
    
    /** 프로젝트 목록 */
    public list: any[] = [];
    
    /** 총 개수 */
    public total: number = 0;

    /** 현재 페이지 */
    public page: number = 1;

    /** 페이지당 개수 */
    public dump: number = 10;

    /** 검색어 */
    public search: string = '';

    /** 구분 필터 */
    public project_type: string = '전체';

    /** 정렬 기준 (default, name, date, status) */
    public sort: string = 'default';

    /** 정렬 순서 (ASC, DESC) */
    public order: string = 'DESC';

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        // URL 쿼리 파라미터에서 상태 읽기
        try {
            const urlParams = new URLSearchParams(window.location.search);
            this.page = parseInt(urlParams.get('page') || '1');
            this.search = urlParams.get('search') || '';
            this.project_type = urlParams.get('type') || '전체';
            this.sort = urlParams.get('sort') || 'default';
            this.order = urlParams.get('order') || 'DESC';
        } catch (e) { }

        await this.load(this.page);
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    /**
     * 용역 목록 조회
     */
    public async load(page: number = 1) {
        if (page < 1) page = 1;
        this.page = page;

        // URL 쿼리 파라미터 업데이트 (새로고침 시 유지용)
        try {
            const url = new URL(window.location.href);
            url.searchParams.set('page', String(this.page));
            url.searchParams.set('search', this.search);
            url.searchParams.set('type', this.project_type);
            url.searchParams.set('sort', this.sort);
            url.searchParams.set('order', this.order);
            window.history.replaceState({}, '', url.toString());
        } catch (e) { }

        const params = {
            page: this.page,
            dump: this.dump,
            search: this.search,
            type: this.project_type,
            sort: this.sort,
            order: this.order
        };

        const { code, data } = await wiz.call("list", params);
        if (code === 200) {
            this.list = data.list || [];
            this.total = data.total || 0;
        }
        this.ref.detectChanges();
    }

    /**
     * 필터 변경 시 호출
     */
    public async onFilterChange() {
        await this.load(1);
    }

    /**
     * 정렬 변경 시 호출
     */
    public async toggleSort(key: string) {
        if (this.sort === key) {
            this.order = this.order === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sort = key;
            this.order = 'ASC';
        }
        await this.load(1);
    }

    /**
     * 페이지 번호 목록 생성
     */
    public get pages(): number[] {
        const totalPages = Math.ceil(this.total / this.dump) || 1;
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        return pages;
    }

    /**
     * 날짜 형식 변환 (YYYY-MM-DD만 표시)
     */
    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    /**
     * 상세 페이지로 이동
     */
    public async viewDetail(id: string) {
        await this.service.href(`/project/detail/${id}`);
    }

    public async addProject() {
        this.is_add_project = true;
        this.ref.detectChanges();
    }

    /**
     * 모달 닫힘 처리 (등록 성공 시 목록 새로고침)
     */
    public async onModalClose(success: boolean) {
        this.is_add_project = false;
        if (success) {
            await this.load();
        }
        this.ref.detectChanges();
    }

    /**
     * 용역 삭제
     */
    public async deleteProject(id: string) {
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 용역을 삭제하시겠습니까? 관련된 도면과 시설물도 함께 삭제됩니다.',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        
        if (!confirmed) return;

        await this.service.loading.show();
        const { code, data } = await wiz.call("delete", { id });
        await this.service.loading.hide();

        if (code === 200) {
            await this.service.alert.show({
                title: '삭제 완료',
                message: '용역이 삭제되었습니다.',
                status: 'success',
                action: '확인',
                cancel: false
            });
            await this.load();
            this.ref.detectChanges();
        } else {
            await this.service.alert.show({
                title: '삭제 실패',
                message: data || '삭제에 실패했습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
        }
    }
}

export default PageProjectListComponent;